import { useState, FC, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';

//Actions
import { getListAddress } from "../../../../../actions/shipperAction";

//Components
import Component from "./Component";

// Interfaces
import { AddressInterface } from "../../definitions";
import { WrapperInterface } from "./definitions";

// Render Wrapper
const PickupAddressContainer: FC<WrapperInterface> = ({
  addresses,
  defaultAddress: _defaultAddress,
  selectedAddress: _selectedAddress, // ini di set setelah user udah continue ke logistic
  onBack,
  continueAction,
  pickupUnmountCallback
}) => {
  const [data, setData] = useState<Array<AddressInterface>>(addresses || []);
  const [fetchingAddressList, setFethingAddressList] = useState(addresses ? false : true);
  const [process, setProcess] = useState(addresses ? "have-address" : "no-address")
  const [selectedAddress, setSelectedAddress] = useState<AddressInterface | null>(null);
  const [choosenAddress, setChoosenAddress] = useState<AddressInterface | null>(_selectedAddress);
  const [defaultAddress, setDefaultAddress] = useState<AddressInterface | null>(_defaultAddress);
  
  /**Handlers */
  //Process handlers
  const toHaveAddress = () => setProcess("have-address");
  const toNoAddress = () => setProcess("no-address");
  const toAddAddress = () => setProcess("add-address");
  const toSelectAddress = () => setProcess("select-address");

  const fetchAddressList = async (onMount?: boolean) => {
    try {
      !onMount && setFethingAddressList(true)

      await getListAddress()
        .then(res => res?.data)
        .then(res => {
          if (!res?.data || !res?.data?.length) {
            toNoAddress()
            return;
          };

          const _defaultAdrs = res?.data?.filter(adrs => adrs.is_default)

          setDefaultAddress(_defaultAdrs[0] || null)
          setData(res?.data)

          onMount ? toHaveAddress() : toSelectAddress()
        })
        .catch(err => { throw err })
        .finally(() => {
          setFethingAddressList(false)
        })
    } catch (err) {
      setFethingAddressList(false)
      onMount && toNoAddress()
      console.log(err, "Error when fething address list")
    }
  }

  const resetEdit = () => {
    setSelectedAddress(null);
  }
  const submitSuccess = (data) => {
    resetEdit()
    fetchAddressList()
    if(choosenAddress?.id == data?.id) {
      setChoosenAddress(data)
    }
    toSelectAddress()

  }
  const continueHandler = () => continueAction(choosenAddress || defaultAddress);
  const backHandler = () => onBack();
  const addAddressBack = () => {
    const len = data.length;
    resetEdit()
    len ? toSelectAddress() : toNoAddress()
  }
  const selectAddressBack = () => {
    resetEdit()
    toHaveAddress()
  }
  const getDefaultAddress = (addrs: Array<AddressInterface>) => {
    const tempAddress = addrs.filter(adr => adr.is_default);
    setDefaultAddress(tempAddress[0])
  }
  const addEditAddress = (addrs?: AddressInterface) => {
    addrs && setSelectedAddress(addrs)
    toAddAddress()
  }
  const selectAddressConfirm = (addrs: AddressInterface | null) => {
    setChoosenAddress(addrs)
    toHaveAddress()
  }

  /**Use effects */
  useEffect(() => {
    if (data?.length) {
      getDefaultAddress(data)
    }
  }, [data])

  useEffect(() => {
    if(!addresses || !addresses.length){
      fetchAddressList(true)
    }
  }, [])

  useEffect(() => {
    return () => {
      pickupUnmountCallback()
    }
  }, [])

  /**Render component */
  return (
    <Component
      data={data}
      process={process}
      selectedAddress={selectedAddress}
      fetchingAddressList={fetchingAddressList}
      choosenAddress={choosenAddress || defaultAddress}
      submitSuccess={submitSuccess}
      backHandler={backHandler}
      fetchAddressList={fetchAddressList}
      continueHandler={continueHandler}
      toSelectAddress={toSelectAddress}
      toAddAddress={toAddAddress}
      addAddressBack={addAddressBack}
      selectAddressBack={selectAddressBack}
      addEditAddress={addEditAddress}
      selectAddressConfirm={selectAddressConfirm}
    />
  )
}
PickupAddressContainer.defaultProps = {
  onBack: () => { }
}

export default PickupAddressContainer;